import { IMobileBuyBarView, IVariantGridView } from 'store/types/buyBarTypes';

export const TABS = {
  NEW: 'new' as IMobileBuyBarView,
  USED: 'used' as IMobileBuyBarView,
  OFFER: 'offer' as IMobileBuyBarView,
};

export const TAB_VIEWS = { ...TABS, NONE: 'none' as IMobileBuyBarView };

export const VARIANT_GRID_VIEW = {
  NONE: 'none' as IVariantGridView,
  DEFECTS: 'defects' as IVariantGridView,
  SPECIAL: 'special' as IVariantGridView,
};
